import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { ServiceProviderMain } from '../../organisms/settings/serviceProvider/ServiceProviderMain';

/**
 * presentations/components/pages/settings/ServiceProvidersPage.tsx
 */
const ServiceProvidersPage: React.FC = () => (
  <SettingsAccessControl allowedRoles='systemAdmin'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <ServiceProviderMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default ServiceProvidersPage;
